<button kendoButton [primary]="true" [icon]="'cart'" class="small-margin" (click)="addToCart()" [disabled]="loading">
  {{ 'ajouter au panier' | uppercase }}
  <ng-container *ngIf="numberAlreadyAdded > 0"> ({{ numberAlreadyAdded }}) </ng-container>
</button>
